import { t } from "i18next";
import OutputData from "../../../components/ui/output_data/OutputData";
import styles from "./styles/SummaryOutput.module.css";

/**
 * Summary output component (pair)
 * For 2 entries
 */
const SummaryOutputDouble = ({
    outputMainLabel, // {String} - The main label for the output
    label1, // {String} - The first output label
    label2, // {String} - The second output label
    value1, // {String|Number} - The first output value to be displayed
    value2, // {String|Number} - The second output value to be displayed
}) => {
    return (
        <div
            className={`${styles.main_summary_output_container_double} flex-container`}
        >
            <div
                className={`${styles.summary_output_container}  flex-container`}
            >
                <div className={`${styles.summary_double_lable_width} `}>
                    <h3
                        className={`${styles.summary_output_label}  flex-container`}
                    >
                        <span className={`${styles.text}`}>
                            {t(outputMainLabel)}
                        </span>{" "}
                        <span className={`${styles.colon}`}>:</span>
                    </h3>
                </div>
                <div
                    className={`${styles.values_output_container}  flex-container`}
                >
                    <div
                        className={`${styles.summary_output_value_container} ${styles.summary_output_value_first} ${styles.summary_double_value_width} flex-container`}
                    >
                        <OutputData
                            data={value1}
                            align={"center"}
                            label={t(label1)}
                        />
                    </div>
                    <div
                        className={`${styles.summary_output_value_container}  ${styles.summary_double_value_width}  flex-container`}
                    >
                        <OutputData
                            data={value2}
                            align={"center"}
                            label={t(label2)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SummaryOutputDouble;
